"use client";
import SvgAssignmentFilled from "./assignment-filled.svg.js";
import SvgAssignmentOutlined from "./assignment-outlined.svg.js";
import SvgAssignmentRound from "./assignment-round.svg.js";
import SvgAssignmentSharp from "./assignment-sharp.svg.js";
import SvgAutomaticGearFilled from "./automatic_gear-filled.svg.js";
import SvgAutomaticGearOutlined from "./automatic_gear-outlined.svg.js";
import SvgAutomaticGearRound from "./automatic_gear-round.svg.js";
import SvgAutomaticGearSharp from "./automatic_gear-sharp.svg.js";
import SvgBinocularsFilled from "./binoculars-filled.svg.js";
import SvgBinocularsOutlined from "./binoculars-outlined.svg.js";
import SvgBinocularsRound from "./binoculars-round.svg.js";
import SvgBinocularsSharp from "./binoculars-sharp.svg.js";
import SvgBoltFilled from "./bolt-filled.svg.js";
import SvgBoltOutlined from "./bolt-outlined.svg.js";
import SvgBoltRound from "./bolt-round.svg.js";
import SvgBoltSharp from "./bolt-sharp.svg.js";
import SvgBuildFilled from "./build-filled.svg.js";
import SvgBuildOutlined from "./build-outlined.svg.js";
import SvgBuildRound from "./build-round.svg.js";
import SvgBuildSharp from "./build-sharp.svg.js";
import SvgCalculateFilled from "./calculate-filled.svg.js";
import SvgCalculateOutlined from "./calculate-outlined.svg.js";
import SvgCalculateRound from "./calculate-round.svg.js";
import SvgCalculateSharp from "./calculate-sharp.svg.js";
import SvgCalendarFilled from "./calendar-filled.svg.js";
import SvgCalendarOutlined from "./calendar-outlined.svg.js";
import SvgCalendarRound from "./calendar-round.svg.js";
import SvgCalendarSharp from "./calendar-sharp.svg.js";
import SvgCarFilled from "./car-filled.svg.js";
import SvgCarOutlined from "./car-outlined.svg.js";
import SvgCarRound from "./car-round.svg.js";
import SvgCarSharp from "./car-sharp.svg.js";
import SvgCarCrashFilled from "./car_crash-filled.svg.js";
import SvgCarCrashOutlined from "./car_crash-outlined.svg.js";
import SvgCarCrashRound from "./car_crash-round.svg.js";
import SvgCarCrashSharp from "./car_crash-sharp.svg.js";
import SvgChangeFilled from "./change-filled.svg.js";
import SvgChangeOutlined from "./change-outlined.svg.js";
import SvgChangeRound from "./change-round.svg.js";
import SvgChangeSharp from "./change-sharp.svg.js";
import SvgCodeFilled from "./code-filled.svg.js";
import SvgCodeOutlined from "./code-outlined.svg.js";
import SvgCodeRound from "./code-round.svg.js";
import SvgCodeSharp from "./code-sharp.svg.js";
import SvgContractFilled from "./contract-filled.svg.js";
import SvgContractOutlined from "./contract-outlined.svg.js";
import SvgContractRound from "./contract-round.svg.js";
import SvgContractSharp from "./contract-sharp.svg.js";
import SvgEditFilled from "./edit-filled.svg.js";
import SvgEditOutlined from "./edit-outlined.svg.js";
import SvgEditRound from "./edit-round.svg.js";
import SvgEditSharp from "./edit-sharp.svg.js";
import SvgExploreFilled from "./explore-filled.svg.js";
import SvgExploreOutlined from "./explore-outlined.svg.js";
import SvgExploreRound from "./explore-round.svg.js";
import SvgExploreSharp from "./explore-sharp.svg.js";
import SvgGlassDamageFilled from "./glass_damage-filled.svg.js";
import SvgGlassDamageOutlined from "./glass_damage-outlined.svg.js";
import SvgGlassDamageRound from "./glass_damage-round.svg.js";
import SvgGlassDamageSharp from "./glass_damage-sharp.svg.js";
import SvgHomeFilled from "./home-filled.svg.js";
import SvgHomeOutlined from "./home-outlined.svg.js";
import SvgHomeRound from "./home-round.svg.js";
import SvgHomeSharp from "./home-sharp.svg.js";
import SvgLightbulbFilled from "./lightbulb-filled.svg.js";
import SvgLightbulbOutlined from "./lightbulb-outlined.svg.js";
import SvgLightbulbRound from "./lightbulb-round.svg.js";
import SvgLightbulbSharp from "./lightbulb-sharp.svg.js";
import SvgLoginFilled from "./login-filled.svg.js";
import SvgLoginOutlined from "./login-outlined.svg.js";
import SvgLoginRound from "./login-round.svg.js";
import SvgLoginSharp from "./login-sharp.svg.js";
import SvgLogoutFilled from "./logout-filled.svg.js";
import SvgLogoutOutlined from "./logout-outlined.svg.js";
import SvgLogoutRound from "./logout-round.svg.js";
import SvgLogoutSharp from "./logout-sharp.svg.js";
import SvgManualGearFilled from "./manual_gear-filled.svg.js";
import SvgManualGearOutlined from "./manual_gear-outlined.svg.js";
import SvgManualGearRound from "./manual_gear-round.svg.js";
import SvgManualGearSharp from "./manual_gear-sharp.svg.js";
import SvgNotificationsFilled from "./notifications-filled.svg.js";
import SvgNotificationsOutlined from "./notifications-outlined.svg.js";
import SvgNotificationsRound from "./notifications-round.svg.js";
import SvgNotificationsSharp from "./notifications-sharp.svg.js";
import SvgPaymentFilled from "./payment-filled.svg.js";
import SvgPaymentOutlined from "./payment-outlined.svg.js";
import SvgPaymentRound from "./payment-round.svg.js";
import SvgPaymentSharp from "./payment-sharp.svg.js";
import SvgPetsFilled from "./pets-filled.svg.js";
import SvgPetsOutlined from "./pets-outlined.svg.js";
import SvgPetsRound from "./pets-round.svg.js";
import SvgPetsSharp from "./pets-sharp.svg.js";
import SvgPlayCircleFilled from "./play_circle-filled.svg.js";
import SvgPlayCircleOutlined from "./play_circle-outlined.svg.js";
import SvgPlayCircleRound from "./play_circle-round.svg.js";
import SvgPlayCircleSharp from "./play_circle-sharp.svg.js";
import SvgQueryStatsFilled from "./query_stats-filled.svg.js";
import SvgQueryStatsOutlined from "./query_stats-outlined.svg.js";
import SvgQueryStatsRound from "./query_stats-round.svg.js";
import SvgQueryStatsSharp from "./query_stats-sharp.svg.js";
import SvgSavingsFilled from "./savings-filled.svg.js";
import SvgSavingsOutlined from "./savings-outlined.svg.js";
import SvgSavingsRound from "./savings-round.svg.js";
import SvgSavingsSharp from "./savings-sharp.svg.js";
import SvgScheduleFilled from "./schedule-filled.svg.js";
import SvgScheduleOutlined from "./schedule-outlined.svg.js";
import SvgScheduleRound from "./schedule-round.svg.js";
import SvgScheduleSharp from "./schedule-sharp.svg.js";
import SvgSearchFilled from "./search-filled.svg.js";
import SvgSearchOutlined from "./search-outlined.svg.js";
import SvgSearchRound from "./search-round.svg.js";
import SvgSearchSharp from "./search-sharp.svg.js";
import SvgSettingsFilled from "./settings-filled.svg.js";
import SvgSettingsOutlined from "./settings-outlined.svg.js";
import SvgSettingsRound from "./settings-round.svg.js";
import SvgSettingsSharp from "./settings-sharp.svg.js";
import SvgShoppingCartFilled from "./shopping_cart-filled.svg.js";
import SvgShoppingCartOutlined from "./shopping_cart-outlined.svg.js";
import SvgShoppingCartRound from "./shopping_cart-round.svg.js";
import SvgShoppingCartSharp from "./shopping_cart-sharp.svg.js";
import SvgSortFilled from "./sort-filled.svg.js";
import SvgSortOutlined from "./sort-outlined.svg.js";
import SvgSortRound from "./sort-round.svg.js";
import SvgSortSharp from "./sort-sharp.svg.js";
import SvgSpeedFilled from "./speed-filled.svg.js";
import SvgSpeedOutlined from "./speed-outlined.svg.js";
import SvgSpeedRound from "./speed-round.svg.js";
import SvgSpeedSharp from "./speed-sharp.svg.js";
import SvgTireFilled from "./tire-filled.svg.js";
import SvgTireOutlined from "./tire-outlined.svg.js";
import SvgTireRound from "./tire-round.svg.js";
import SvgTireSharp from "./tire-sharp.svg.js";
import SvgTrashFilled from "./trash-filled.svg.js";
import SvgTrashOutlined from "./trash-outlined.svg.js";
import SvgTrashRound from "./trash-round.svg.js";
import SvgTrashSharp from "./trash-sharp.svg.js";
import SvgTuneFilled from "./tune-filled.svg.js";
import SvgTuneOutlined from "./tune-outlined.svg.js";
import SvgTuneRound from "./tune-round.svg.js";
import SvgTuneSharp from "./tune-sharp.svg.js";
import SvgVerifiedFilled from "./verified-filled.svg.js";
import SvgVerifiedOutlined from "./verified-outlined.svg.js";
import SvgVerifiedRound from "./verified-round.svg.js";
import SvgVerifiedSharp from "./verified-sharp.svg.js";
import SvgVisibilityOffFilled from "./visibility_off-filled.svg.js";
import SvgVisibilityOffOutlined from "./visibility_off-outlined.svg.js";
import SvgVisibilityOffRound from "./visibility_off-round.svg.js";
import SvgVisibilityOffSharp from "./visibility_off-sharp.svg.js";
import SvgVisibilityOnFilled from "./visibility_on-filled.svg.js";
import SvgVisibilityOnOutlined from "./visibility_on-outlined.svg.js";
import SvgVisibilityOnRound from "./visibility_on-round.svg.js";
import SvgVisibilityOnSharp from "./visibility_on-sharp.svg.js";
const assignment = {
  filled: SvgAssignmentFilled,
  outlined: SvgAssignmentOutlined,
  round: SvgAssignmentRound,
  sharp: SvgAssignmentSharp
};
const automatic_gear = {
  filled: SvgAutomaticGearFilled,
  outlined: SvgAutomaticGearOutlined,
  round: SvgAutomaticGearRound,
  sharp: SvgAutomaticGearSharp
};
const binoculars = {
  filled: SvgBinocularsFilled,
  outlined: SvgBinocularsOutlined,
  round: SvgBinocularsRound,
  sharp: SvgBinocularsSharp
};
const bolt = {
  filled: SvgBoltFilled,
  outlined: SvgBoltOutlined,
  round: SvgBoltRound,
  sharp: SvgBoltSharp
};
const build = {
  filled: SvgBuildFilled,
  outlined: SvgBuildOutlined,
  round: SvgBuildRound,
  sharp: SvgBuildSharp
};
const calculate = {
  filled: SvgCalculateFilled,
  outlined: SvgCalculateOutlined,
  round: SvgCalculateRound,
  sharp: SvgCalculateSharp
};
const calendar = {
  filled: SvgCalendarFilled,
  outlined: SvgCalendarOutlined,
  round: SvgCalendarRound,
  sharp: SvgCalendarSharp
};
const car = {
  filled: SvgCarFilled,
  outlined: SvgCarOutlined,
  round: SvgCarRound,
  sharp: SvgCarSharp
};
const car_crash = {
  filled: SvgCarCrashFilled,
  outlined: SvgCarCrashOutlined,
  round: SvgCarCrashRound,
  sharp: SvgCarCrashSharp
};
const change = {
  filled: SvgChangeFilled,
  outlined: SvgChangeOutlined,
  round: SvgChangeRound,
  sharp: SvgChangeSharp
};
const code = {
  filled: SvgCodeFilled,
  outlined: SvgCodeOutlined,
  round: SvgCodeRound,
  sharp: SvgCodeSharp
};
const contract = {
  filled: SvgContractFilled,
  outlined: SvgContractOutlined,
  round: SvgContractRound,
  sharp: SvgContractSharp
};
const edit = {
  filled: SvgEditFilled,
  outlined: SvgEditOutlined,
  round: SvgEditRound,
  sharp: SvgEditSharp
};
const explore = {
  filled: SvgExploreFilled,
  outlined: SvgExploreOutlined,
  round: SvgExploreRound,
  sharp: SvgExploreSharp
};
const glass_damage = {
  filled: SvgGlassDamageFilled,
  outlined: SvgGlassDamageOutlined,
  round: SvgGlassDamageRound,
  sharp: SvgGlassDamageSharp
};
const home = {
  filled: SvgHomeFilled,
  outlined: SvgHomeOutlined,
  round: SvgHomeRound,
  sharp: SvgHomeSharp
};
const lightbulb = {
  filled: SvgLightbulbFilled,
  outlined: SvgLightbulbOutlined,
  round: SvgLightbulbRound,
  sharp: SvgLightbulbSharp
};
const login = {
  filled: SvgLoginFilled,
  outlined: SvgLoginOutlined,
  round: SvgLoginRound,
  sharp: SvgLoginSharp
};
const logout = {
  filled: SvgLogoutFilled,
  outlined: SvgLogoutOutlined,
  round: SvgLogoutRound,
  sharp: SvgLogoutSharp
};
const manual_gear = {
  filled: SvgManualGearFilled,
  outlined: SvgManualGearOutlined,
  round: SvgManualGearRound,
  sharp: SvgManualGearSharp
};
const notifications = {
  filled: SvgNotificationsFilled,
  outlined: SvgNotificationsOutlined,
  round: SvgNotificationsRound,
  sharp: SvgNotificationsSharp
};
const payment = {
  filled: SvgPaymentFilled,
  outlined: SvgPaymentOutlined,
  round: SvgPaymentRound,
  sharp: SvgPaymentSharp
};
const pets = {
  filled: SvgPetsFilled,
  outlined: SvgPetsOutlined,
  round: SvgPetsRound,
  sharp: SvgPetsSharp
};
const play_circle = {
  filled: SvgPlayCircleFilled,
  outlined: SvgPlayCircleOutlined,
  round: SvgPlayCircleRound,
  sharp: SvgPlayCircleSharp
};
const query_stats = {
  filled: SvgQueryStatsFilled,
  outlined: SvgQueryStatsOutlined,
  round: SvgQueryStatsRound,
  sharp: SvgQueryStatsSharp
};
const savings = {
  filled: SvgSavingsFilled,
  outlined: SvgSavingsOutlined,
  round: SvgSavingsRound,
  sharp: SvgSavingsSharp
};
const schedule = {
  filled: SvgScheduleFilled,
  outlined: SvgScheduleOutlined,
  round: SvgScheduleRound,
  sharp: SvgScheduleSharp
};
const search = {
  filled: SvgSearchFilled,
  outlined: SvgSearchOutlined,
  round: SvgSearchRound,
  sharp: SvgSearchSharp
};
const settings = {
  filled: SvgSettingsFilled,
  outlined: SvgSettingsOutlined,
  round: SvgSettingsRound,
  sharp: SvgSettingsSharp
};
const shopping_cart = {
  filled: SvgShoppingCartFilled,
  outlined: SvgShoppingCartOutlined,
  round: SvgShoppingCartRound,
  sharp: SvgShoppingCartSharp
};
const sort = {
  filled: SvgSortFilled,
  outlined: SvgSortOutlined,
  round: SvgSortRound,
  sharp: SvgSortSharp
};
const speed = {
  filled: SvgSpeedFilled,
  outlined: SvgSpeedOutlined,
  round: SvgSpeedRound,
  sharp: SvgSpeedSharp
};
const tire = {
  filled: SvgTireFilled,
  outlined: SvgTireOutlined,
  round: SvgTireRound,
  sharp: SvgTireSharp
};
const trash = {
  filled: SvgTrashFilled,
  outlined: SvgTrashOutlined,
  round: SvgTrashRound,
  sharp: SvgTrashSharp
};
const tune = {
  filled: SvgTuneFilled,
  outlined: SvgTuneOutlined,
  round: SvgTuneRound,
  sharp: SvgTuneSharp
};
const verified = {
  filled: SvgVerifiedFilled,
  outlined: SvgVerifiedOutlined,
  round: SvgVerifiedRound,
  sharp: SvgVerifiedSharp
};
const visibility_off = {
  filled: SvgVisibilityOffFilled,
  outlined: SvgVisibilityOffOutlined,
  round: SvgVisibilityOffRound,
  sharp: SvgVisibilityOffSharp
};
const visibility_on = {
  filled: SvgVisibilityOnFilled,
  outlined: SvgVisibilityOnOutlined,
  round: SvgVisibilityOnRound,
  sharp: SvgVisibilityOnSharp
};
export {
  assignment,
  automatic_gear,
  binoculars,
  bolt,
  build,
  calculate,
  calendar,
  car,
  car_crash,
  change,
  code,
  contract,
  edit,
  explore,
  glass_damage,
  home,
  lightbulb,
  login,
  logout,
  manual_gear,
  notifications,
  payment,
  pets,
  play_circle,
  query_stats,
  savings,
  schedule,
  search,
  settings,
  shopping_cart,
  sort,
  speed,
  tire,
  trash,
  tune,
  verified,
  visibility_off,
  visibility_on
};
